import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Layout from '../../../Components/Layout/Layout';
import CalendarFilters from '../../../Components/CalendarFilters/Index';
import CalenderModals from '../../../Components/Modals/Index';

const localizer = momentLocalizer(moment);

const CustomToolbar = ({ label, onNavigate }) => {
  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group-dash">
        <button type="button" onClick={() => onNavigate('PREV')}>
          &lt;&lt;
        </button>
        <span className="rbc-toolbar-label">{label}</span>
        <button type="button" onClick={() => onNavigate('NEXT')}>
          &gt;&gt;
        </button>
      </span>
    </div>
  );
};

const WeeklyView = () => {
  const [events, setEvents] = useState([
    {
      title: 'Johnathan Bridges',
      start: new Date(2024, 9, 16, 10, 0),
      end: new Date(2024, 9, 16, 12, 0),
      desc: 'Aptiv Tech Experience\nBR&E VISIT',
      backgroundColor: '#e0bbf4',
      textColor: '#2d0057',
    },
    {
      title: 'Darnita Bradley',
      start: new Date(2024, 9, 11, 8, 0),
      end: new Date(2024, 9, 11, 17, 0),
      desc: 'Athens Armory Vibrant Community/ACGP Project\nGroundbreaking',
      backgroundColor: '#f3e5ab',
      textColor: '#7d4b12',
    },
  ]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [calendarView, setCalendarView] = useState('week');

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedEvent(null);
  };

  const eventPropGetter = (event) => ({
    style: {
      backgroundColor: event.backgroundColor,
      color: event.textColor,
      padding: '5px 5px',
      border: 'none',
    },
  });

  return (
    <Layout>
      <CalendarFilters onView={setCalendarView} />
      <div style={{ height: '80vh', margin: '20px' }}>
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: '100%' }}
          eventPropGetter={eventPropGetter}
          view="week" 
          onView={() => {}} 
          components={{
            toolbar: CustomToolbar,
            event: ({ event }) => (
              <div
                className="custom-event"
                onClick={() => handleEventClick(event)}
              >
                <strong
                  style={{
                    backgroundColor: event.textColor,
                    color: event.backgroundColor,
                  }}
                >
                  {event.title}
                </strong>
                <span>{event.desc}</span>
              </div>
            ),
          }}
        />
      </div>
      <CalenderModals
          open={modalOpen}
          onClose={handleModalClose}
          event={selectedEvent}
        />
    </Layout>
  );
};

export default WeeklyView;
